import { createContext } from 'react';
import axios from '../../../../../api/axios';

export const store = createContext(null);
export const initialState = {
  order: null,
  bidders: null,
  transactions: null,
  selectedPayment: {
    payment: null,
    orderId: null,
    userId: null,
    paymentType: null,
    credit:null
  },
};
export const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case 'BIDDERS':
      const { bidders, order, transactions } = payload;
      return { ...state, bidders, order, transactions };
    case 'SHOW_PAYMENT_DIALOG':
      const { paymentType, payment, userId, orderId,credit } = payload;
      return {
        ...state,
        selectedPayment: { paymentType, payment, userId, orderId,credit },
      };
    case 'CLOSE_PAYMENT_DIALOG':
      return {
        ...state,
        selectedPayment: {
          paymentType: null,
          payment: null,
          userId: null,
          orderId: null,
          credit:null
        },
      };
    default:
      return { ...state };
  }
};
export const actions = {
  fetchingBidders: async function (orderId) {
    try {
      const {
        data: { bidders, order, transactions },
      } = await axios.post(`/api/v1/admin/orders/getWaybill`,{orderId});
      return { bidders, order, transactions };
    } catch (error) {
      throw error;
    }
  },
  addReadyWaybill:async(orderId,userId)=>{
    try {
      const {data} = await axios.post(`/api/v1/admin/orders/getWaybill/addReadyWaybill`,{
        userId,orderId
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
};
